"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChildAttendanceIntentionApplicationService = void 0;
const operators_1 = require("rxjs/operators");
class ChildAttendanceIntentionApplicationService {
    constructor(repo, bubblesApplicationService) {
        this.repo = repo;
        this.bubblesApplicationService = bubblesApplicationService;
    }
    getAttendanceIntentionsForChild(tenantId, childId) {
        return this.repo.findForChild(tenantId, childId);
    }
    getAttendanceIntentionsForChildInWeek(tenantId, childId, week) {
        return this.repo.findForChildInWeek(tenantId, childId, week);
    }
    getAttendanceIntentionsForWeek(tenantId, weekIdentifier) {
        return this.repo.findForWeek(tenantId, weekIdentifier);
    }
    async registerChildAttendanceIntentionForWeek(newIntention) {
        const attendanceForWeek = await this.repo
            .findForChildInWeek(newIntention.tenantId, newIntention.childId, newIntention.weekIdentifier)
            .pipe(operators_1.first())
            .toPromise();
        if (attendanceForWeek != null) {
            return {
                status: 'rejected',
                reason: 'Already registered for this week',
            };
        }
        await this.repo.put(newIntention);
        return {
            status: 'accepted',
        };
    }
    async unregisterPendingChildAttendanceIntentionForWeek(tenantId, childId, week) {
        const attendanceForWeek = await this.repo
            .findForChildInWeek(tenantId, childId, week)
            .pipe(operators_1.first())
            .toPromise();
        if (attendanceForWeek == null) {
            return {
                status: 'rejected',
                reason: 'Not registered for this week',
            };
        }
        if (attendanceForWeek.status !== 'pending') {
            return {
                status: 'rejected',
                reason: 'This attendance intention is not in the pending state',
            };
        }
        await this.repo.remove(tenantId, childId, week);
        return {
            status: 'accepted',
        };
    }
    async unregisterChildAttendanceIntentionForWeek(tenantId, childId, week) {
        const attendanceForWeek = await this.repo
            .findForChildInWeek(tenantId, childId, week)
            .pipe(operators_1.first())
            .toPromise();
        if (attendanceForWeek == null) {
            return {
                status: 'rejected',
                reason: 'Not registered for this week',
            };
        }
        await this.repo.remove(tenantId, childId, week);
        return {
            status: 'accepted',
        };
    }
    /**
     * After moving a child from the registration waiting list, call this method to move attendance intentions
     *
     * Does nothing when child is not on registration waiting list
     */
    async moveChildFromRegistrationWaitingList(tenantId, childOnRegistrationWaitingListId, newChildId) {
        const attendances = (await this.getAttendanceIntentionsForChild(tenantId, childOnRegistrationWaitingListId)
            .pipe(operators_1.first())
            .toPromise()).filter((att) => att.status === 'child-on-registration-waiting-list');
        if (attendances.length === 0) {
            // No attendance intentions => not a failure
            return {
                status: 'accepted',
            };
        }
        await Promise.all(attendances.map(async (att) => {
            await this.repo.remove(tenantId, childOnRegistrationWaitingListId, att.weekIdentifier);
            await this.repo.put(att.withStatus('pending').withChildId(newChildId));
        }));
        return {
            status: 'accepted',
        };
    }
    async approveChildAttendanceIntentionForWeek(tenantId, childId, week, bubbleName) {
        const attendance = await this.getAttendanceIntentionsForChildInWeek(tenantId, childId, week)
            .pipe(operators_1.first())
            .toPromise();
        if (attendance == null) {
            return {
                status: 'rejected',
                reason: `No attendance found to approve for ${childId} in week ${week}`,
            };
        }
        const bubbleForChild = await this.bubblesApplicationService
            .bubbleForChild(tenantId, week, childId)
            .pipe(operators_1.first())
            .toPromise();
        if (bubbleName != null && (bubbleForChild === null || bubbleForChild === void 0 ? void 0 : bubbleForChild.name) != bubbleName) {
            return {
                status: 'rejected',
                reason: `Child ${childId} is not in bubble ${bubbleName}, can't approve attendance`,
            };
        }
        await this.repo.put(attendance.withStatus('accepted'));
        return {
            status: 'accepted',
        };
    }
    async rejectChildAttendanceIntentionForWeek(tenantId, childId, week) {
        const attendance = await this.getAttendanceIntentionsForChildInWeek(tenantId, childId, week)
            .pipe(operators_1.first())
            .toPromise();
        if (attendance == null) {
            return {
                status: 'rejected',
                reason: `Could not find attendance for ${childId}, can't reject attendance`,
            };
        }
        await this.repo.put(attendance.withStatus('rejected'));
        return {
            status: 'accepted',
        };
    }
}
exports.ChildAttendanceIntentionApplicationService = ChildAttendanceIntentionApplicationService;
//# sourceMappingURL=child-attendance-intention.application-service.js.map